import { useEffect } from "react";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import PageMeta from "../../components/common/PageMeta";

export default function ResetPasswordRedirect() {
  const navigate = useNavigate();
  const { token } = useParams<{ token: string }>();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const email = searchParams.get("email") || "";
    const next = new URLSearchParams();
    if (token) next.set("token", token);
    if (email) next.set("email", email);
    navigate(`/reset-password?${next.toString()}`, { replace: true });
  }, [navigate, searchParams, token]);

  return (
    <>
      <PageMeta title="Reset Password - Neo" description="Redirecting to reset password." />
      <div className="flex min-h-[60vh] items-center justify-center bg-gray-50 dark:bg-[#07090E]">
        <div className="inline-block h-10 w-10 animate-spin rounded-full border-b-2 border-brand-500" />
      </div>
    </>
  );
}

